import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const ModalNetInstallation = ({ show, onHide, onSkip, onAccept }) => {
  const isLogin = useSelector((state) => state.auth.status_login);
  const userid = useSelector((state) => state.auth.userid);
  const dataLogin = useSelector((state) => state.auth.data_login);
  const location = useLocation();
  const dispatch = useDispatch();
  const { status_login } = useSelector((state) => state.auth);
  const { paymentMethod } = useSelector((state) => state.cart);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingSkip, setLoadingSkip] = useState(false);
  const [message, setMessage] = useState("");

  const handleAccept = async () => {
    if (loadingAccept || loadingSkip) return; // Prevent double click
    
    if (status_login === true && paymentMethod && location.pathname === "/ordersummary") {
        const clientData = dataLogin?.client;
        
        if (!clientData) {
            console.log("Client data not found");
            return;
        }
        
        const clientId = clientData.id;
        let clientPhone = clientData.phonenumber;
        const clientEmail = clientData.email;
        
        if (!clientId) {
            console.log("Client ID not found");
            return;
        }

        if (!clientPhone) {
            clientPhone = "-";
        }

        const url = `${process.env.REACT_APP_BASE_API}order/apis/sendEmailForRelabs.php?&clientid=${clientId}&address1=${clientData.address1 || ''}&name=${clientData.firstname || ''}&phone=${clientPhone}&email=${clientEmail || ''}`;

        try {
            setLoadingAccept(true);
            
            // Add timeout to prevent hanging
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 second timeout
            
            const response = await fetch(url, {
                method: 'POST',
                signal: controller.signal
            });
            
            clearTimeout(timeoutId);

            const result = await response.json();
            
            if (result.code === 200) {
                setMessage("Terima Kasih, Kami akan segera menginformasikan kembali kepada Anda melalui kontak email/telepon yang terdaftar.");
                // Update status in CheckoutTable
                window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
                    detail: { status: 'Sudah Dikirim' }
                }));
                setTimeout(() => {
                    onAccept && onAccept();
                }, 3000);
            } else {
                setMessage(result.data || result.message || "Maaf, terjadi kesalahan. Silakan coba lagi nanti.");
                setTimeout(() => {
                    onHide && onHide();
                }, 3000);
            }
        } catch (error) {
            console.error("Error sending email:", error);
            if (error.name === 'AbortError') {
                setMessage("Permintaan timeout. Silakan coba lagi nanti.");
            } else {
                setMessage("Maaf, terjadi kesalahan jaringan. Silakan coba lagi nanti.");
            }
            setTimeout(() => {
                onHide && onHide();
            }, 3000);
        } finally {
            setLoadingAccept(false);
        }
    }
  };

  const handleSkip = async () => {
    if (loadingAccept || loadingSkip) return; // Prevent double click
    
    const clientEmail = dataLogin?.client?.email;
    
    if (!clientEmail) {
        console.log("Client email not found");
        return;
    }

    try {
        setLoadingSkip(true);
        
        // Add timeout to prevent hanging
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 15000); // 15 second timeout
        
        const url = `${process.env.REACT_APP_BASE_API}order/apis/sendEmailForRelabs.php?action=skip&email=${encodeURIComponent(clientEmail)}`;
        const response = await fetch(url, {
            signal: controller.signal
        });
        
        clearTimeout(timeoutId);
        const result = await response.json();
        
        if (result.code === 200) {
            setMessage("Penawaran internet berhasil dilewati. Melanjutkan ke proses checkout...");
            // Update status in CheckoutTable
            window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
                detail: { status: 'Dilewati' }
            }));
            setTimeout(() => {
                onSkip && onSkip();
            }, 1500);
        } else {
            console.error("Error updating skip status:", result.data);
            setMessage(result.data || "Terjadi kesalahan saat memproses permintaan. Silakan coba lagi.");
            setTimeout(() => {
                onHide && onHide();
            }, 2000);
        }
    } catch (error) {
        console.error("Error skipping offer:", error);
        if (error.name === 'AbortError') {
            setMessage("Permintaan timeout. Silakan coba lagi nanti.");
        } else {
            setMessage("Maaf, terjadi kesalahan jaringan. Silakan coba lagi nanti.");
        }
        setTimeout(() => {
            onHide && onHide();
        }, 2000);
    } finally {
        setLoadingSkip(false);
    }
  };

  const handleClose = () => {
    if (loadingAccept || loadingSkip) return; // Prevent closing during loading
    onHide && onHide();
  };

  const address1 = dataLogin?.client?.address1 || "Alamat Anda";

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton={!loadingAccept && !loadingSkip}>
        <Modal.Title className="text-center">Penawaran Khusus</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center mt-3">
        {message ? (
          <div>
            <p style={{ fontSize: "18px" }}>{message}</p>
          </div>
        ) : (
          <div>
            <p style={{ fontSize: "18px" }}>
              <strong>Selamat!</strong> Alamat Anda yang berlokasi di <strong>{address1}</strong> kemungkinan tersedia provider Golden Fast Network Internet. Apakah Anda tertarik untuk mendapatkan penawaran Golden Fast Network Internet?
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        {!message && (
          <div className="row w-100">
            <div className="col-lg-6 col-12">
              <button 
                className={`btn btn-modal-outline-daftar-secondary w-100 ${(loadingAccept || loadingSkip) ? 'disabled' : ''}`}
                onClick={handleSkip}
                disabled={loadingAccept || loadingSkip}
                style={(loadingAccept || loadingSkip) ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
              >
                {loadingSkip ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Memproses...
                  </>
                ) : (
                  "Nanti Saja"
                )}
              </button>
            </div>
            <div className="col-lg-6 col-12">
              <button 
                className={`btn btn-modal-confirmation w-100 ${(loadingAccept || loadingSkip) ? 'disabled' : ''}`}
                onClick={handleAccept} 
                disabled={loadingAccept || loadingSkip}
                style={(loadingAccept || loadingSkip) ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
              >
                {loadingAccept ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Mengirim...
                  </>
                ) : (
                  "Ya, Saya Bersedia"
                )}
              </button>
            </div>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalNetInstallation;
